import React, { useState } from 'react'
import { RouteProp } from '@react-navigation/native'
import { StackNavigationProp } from '@react-navigation/stack'
import { View, ScrollView, SafeAreaView } from 'react-native'
import { useDispatch } from 'react-redux'
import tw from 'tailwind-rn'

import { HGButton, HGHeading, HGText, HGView } from '../../components/HGUI'
import { RootStackParamList } from '../../navigators/AppNavigator'
import ActionCreators from '../../store/actions'
import ChangePasswordForm from '../settings/ChangePasswordForm'
import HansGretelLogo from '../auth/HansGretelLogo'

type Props = {
  route: RouteProp<RootStackParamList, 'ResetPassword'>
  navigation: StackNavigationProp<RootStackParamList>
}

const ResetPasswordScreen = (props: Props) => {
  const {
    navigation,
    route: { params },
  } = props
  const [success, setSuccess] = useState<boolean>(false)
  const [error, setError] = useState<unknown | null>(null)
  const dispatch = useDispatch()
  const { token } = params || {}
  // const { loggedIn } = useSelector((state) => state.user)

  const performUserPasswordChange = async (values, setSubmitting) => {
    const { password } = values

    setSubmitting(true)
    try {
      await dispatch(
        ActionCreators.resetUserPassword({ newPassword: password, token })
      )
      setSuccess(true)
    } catch (e) {
      setError(e)
      console.warn(e)
    } finally {
      setSubmitting(false)
    }
  }

  const handleUserReset = async () => {
    try {
      await dispatch(ActionCreators.logoutUser())
      navigation.replace('SignedOut', { screen: 'SignIn' })
    } catch (e) {
      console.warn(e)
    }
  }

  return (
    <SafeAreaView style={tw('flex-1')}>
      <ScrollView>
        <HGView>
          <View style={tw('px-3')}>
            <View style={tw('mt-24 mb-8 self-center')}>
              <HansGretelLogo />
            </View>

            <HGHeading>Passwort zurücksetzen</HGHeading>

            {!token && (
              <HGText style={tw('mb-6')}>Der Link ist ungültig.</HGText>
            )}

            {token && (
              <>
                {!success && !error && (
                  <>
                    <HGText style={tw('mb-6')}>
                      Bitte geben Sie jetzt Ihr neues Passwort ein.
                    </HGText>

                    <ChangePasswordForm
                      buttonLabel="Passwort zurücksetzen"
                      onSubmit={performUserPasswordChange}
                    />
                  </>
                )}

                {success && (
                  <>
                    <HGText style={tw('mb-6')}>
                      Ihr Passwort wurde erfolgreich zurückgesetzt.
                    </HGText>

                    <HGButton
                      title="Zur Anmeldung"
                      onPress={() => handleUserReset()}
                    />
                  </>
                )}

                {error && (
                  <>
                    <HGText style={tw('mb-6')}>
                      Ein Fehler ist aufgetreten. Bitte überprüfen Sie noch
                      einmal den Link in ihrer E-Mail zum Zurücksetzen des
                      Passwortes.
                    </HGText>

                    <HGButton
                      title="Zurück zum Start"
                      onPress={() =>
                        navigation.replace('SignedOut', {
                          screen: 'SignIn',
                        })
                      }
                    />
                  </>
                )}
              </>
            )}
          </View>
        </HGView>
      </ScrollView>
    </SafeAreaView>
  )
}

export default ResetPasswordScreen
